import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormButtonModule } from '../form-button/form-button.module';
import { BoxDirective } from './box.directive';
import { FormErrorsComponent } from './form-errors.component';
import { FormComponent } from './form.component';
import { ProgressStepComponent } from './progress-step.component';

/**
 * PRIVATE!
 *
 * Use {@link FormsModule}.
 */
@NgModule({
    imports: [
        CommonModule,
        FormButtonModule,
    ],
    declarations: [
        FormComponent,
        BoxDirective,
        FormErrorsComponent,
        ProgressStepComponent,
    ],
    exports: [
        FormComponent,
        BoxDirective, // Muss exportiert werden, sonst geht es nicht (nicht sicher warum das so ist)
        FormErrorsComponent
    ]
})
export class FormFormModule {
}
